import React, { useState } from "react";
import { Tab, Nav, Form } from "react-bootstrap";
import Pagination from "react-bootstrap/Pagination";
import { Link, useNavigate } from "react-router-dom";
import clientimg from "../../asset/images/onboarding-pending/client-img.jpg";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Header from "../../Components/Header";
import Sidebar from "../../Components/Sidebar";
import {
  getName,
  getTabStatus,
  goToClientDashboard,
  mobileNumber,
  noDataFound,
  splitDate,
} from "../../CommonMethhods/CommonMethods";
import Loader from "../../Components/Common/Loader";
import { Constants } from "../../CommonMethhods/Constants";

function OnboardingNotInterested(props) {
  let checkNotInterested = props.checkNotInterested;
  let linecard = props.linecard;

  const [show, setShow] = useState(false);
  let navigate = useNavigate();
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  let serverError = props.serverError;

  let filteredNotInterested = [];

  filteredNotInterested =
    checkNotInterested.length > 0
      ? checkNotInterested.filter((element) => {
          if (element.clienttype == props.onboardingFilter) {
            return element;
          }
        })
      : [];

  return (
    <>
      <Tab.Pane eventKey="NotInterested" className="completedClass">
        <div className="row">
          <div className="col-12">
            <div
              className="oboarding-block-wrapper card-box alert-table text-center"
              onScroll={(e) => props.handleScroll(e)}
            >
              {checkNotInterested.length > 0 ? (
                <div
                  className={` ${
                    linecard === "block-active col-division-5"
                      ? "onboarding-card-wrapper"
                      : ""
                  }`}
                >
                  {checkNotInterested.map((item, index) => {
                    return (
                      <div
                        className={`w-100 bottom-25 ${linecard}`}
                        key={index}
                      >
                        <a
                          onClick={() => {
                            goToClientDashboard(item.clientCode, item.pan);
                            getTabStatus("")
                            navigate("/client-dashboard");
                          }}
                          className="view-detail-btn"
                        >
                          <div className="card-box onboarding-card">
                            <div className="client-img-checkbox-wrapper">
                              <div className="client-img-wrapper">
                                <div className="profile-image">
                                  {item?.clientname
                                    ? getName(item?.clientname)
                                    : "N.A"}
                                </div>

                                {/* <img src={clientimg} alt="" /> */}
                              </div>
                              {/* <div>
                                                <input
                                                    className="styled-checkbox"
                                                    id="checkbox-first"
                                                    type="checkbox"
                                                    value="value1"
                                                />
                                                <label htmlFor="checkbox-first"></label>
                                            </div> */}
                            </div>
                            <div className="onboarding-card-content">
                              <div className="onboarding-card-top">
                                <div className="user-email-wrapper">
                                  <p className="username">
                                    <span>{item?.clientname || "N.A"}</span>
                                  </p>
                                  <p className="email">
                                    {item?.emailid ? item?.emailid : "N.A"}
                                  </p>
                                </div>
                                <ul className="onboarding-content-link-list">
                                  {/* <li className="fingerprint-icon-wrapper">
                                    <span className="icon-fingerprint fingerprint-icon"></span>
                                  </li>
                                  <li className="user-icon-wrapper">
                                    <span className="icon-verified-user"></span>
                                  </li> */}
                                  {/* <li className="onboard-info">
                                                    <Link to="#">OB Screen - Onboard Info</Link>
                                                </li> */}
                                  {/* <li className="onboard-new-link">
                                    <Link to="#" className="">
                                      {Constants.New}
                                    </Link>
                                  </li> */}
                                </ul>
                              </div>
                              {/* <div className="view-btn-wrapper">
                                                        <a target='_blank' href="/Client-Dashboard" className="view-detail-btn">View Details</a>
                                                    </div> */}

                              <div className="clientname-info">
                                <ul className="call-web-wrapper">
                                  <li className="created-time-wrapper">
                                    {/* <div > */}
                                    <span className="icon-calendar onboard-pending-icon"></span>
                                    <span className="onboard-sm-icon-label">
                                      <span>
                                        {item?.createddatetime
                                          ? splitDate(item?.createddatetime)
                                          : "N.A"}
                                      </span>
                                    </span>
                                    {/* </div> */}
                                  </li>
                                  <li className="created-time-wrapper">
                                    {/* <div > */}
                                    <span className="icon-client-code onboard-pending-icon"></span>
                                    <span className="onboard-sm-icon-label">
                                      <span>{item?.clientCode || "N.A"}</span>
                                    </span>
                                    {/* </div> */}
                                  </li>
                                </ul>

                                <div className="client-info-status">
                                  <ul className="call-web-wrapper">
                                    <li>
                                      <span className="icon-phone-icon onboard-pending-icon"></span>
                                      <span className="onboard-sm-icon-label">
                                        <span>
                                          {item?.mobile ? item?.mobile : "N.A"}
                                        </span>
                                      </span>
                                    </li>
                                    {/* <li>
                                     
                                    </li> */}
                                    <li>
                                      <span className="icon-android onboard-pending-icon"></span>
                                      <span className="onboard-sm-icon-label">
                                        <span>
                                          {item?.pan
                                            ? mobileNumber(item?.pan)
                                            : "N.A"}
                                        </span>
                                      </span>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        </a>
                      </div>
                    );
                  })}
                </div>
              ) : (
                serverError && (
                  <h4 className="alert-title mb-0">
                    {noDataFound(serverError)}
                  </h4>
                )
              )}
              {props.scrollLoader && (
                <div className="loader-center">
                  {/* <div className="loader-alignment"> */}
                  <Loader />
                  {/* </div> */}
                </div>
              )}
            </div>
          </div>
        </div>
      </Tab.Pane>
    </>
  );
}

export default OnboardingNotInterested;
